// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper[data-v-47a9cfae] {\n  position: absolute;\n  bottom: 100px;\n  left: 40px;\n  z-index: 999;\n}\n.wrapper .record-control[data-v-47a9cfae] {\n  display: flex;\n  align-items: center;\n  background-color: var(--v-primary-base);\n  border-radius: 8px;\n  height: 32px;\n  font-size: 10px;\n}", ""]);
// Exports
module.exports = exports;
